import { DialogButton } from "arkh";
import { FormattedMessage } from "react-intl";

export function TodoToolbarButtonDeadline(props: {
  expireAt:
    | {
        date: Date;
        formattedDate: string;
      }
    | undefined;
  isLocked: boolean;
  onPress: () => void;
}) {
  if (props.expireAt) {
    return (
      <DialogButton
        mode={props.isLocked ? "locked-active" : "active"}
        onPress={props.onPress}
        indicatorIcon="deadline"
        activeColor={props.expireAt.date < new Date() ? "negative" : undefined}
      >
        {props.expireAt.formattedDate}
      </DialogButton>
    );
  }
  return (
    <DialogButton
      mode="inactive"
      onPress={props.onPress}
      indicatorIcon="deadline"
    >
      <FormattedMessage
        defaultMessage="Deadline"
        description="Todo Toolbar Button Deadline Title"
      />
    </DialogButton>
  );
}
